<div *ngIf='(vmExpWinSumDataView$ | async) as v'>

    <app-page-loader [vm]="v"></app-page-loader>

    <div *ngIf="v.items">
        <!-- Mobile -->
        <div class="d-block d-md-none">
            <div *ngFor="let d of v.items">
                <mdb-card cascade="true" narrower="true" class="pt-3">
                    <div class="row">
                        <div class="col-8 col-sm-6">
                            <div class="view view-cascade gradient-card-header blue-gradient narrower pb-0 pt-2">
                                <h4 class="card-header-title"><a *ngIf='d.confirmationNumber' type="button"
                                        (click)="showDetails(d.segmentRowId);">{{d.confirmationNumber}}</a></h4>
                            </div>
                        </div>
                    </div>
                    <mdb-card-body cascade="true" class="pb-0 pt-2">
                        <mdb-card-text>
                            <div class="row">
                                <div class="col-4 text-right"><b>User Name:</b></div>
                                <div class="col-8"><strong>{{d.userFullName}}</strong></div>
                            </div>
                            <div class="row">
                                <div class="col-4 text-right"><b>User Groups:</b></div>
                                <div class="col-8"><strong>{{d.userGroups}}</strong></div>
                            </div>
                            <div class="row">
                                <div class="col-4 text-right"><b>Prop. Name:</b></div>
                                <div class="col-8"><strong>{{d.propertyName}}</strong></div>
                            </div>
                            <div class="row">
                                <div class="col-4 text-right"><b>Old Value:</b></div>
                                <div class="col-8"><strong>{{d.oldValue | currency}}</strong></div>
                            </div>
                            <div class="row">
                                <div class="col-4 text-right"><b>New Value:</b></div>
                                <div class="col-8"><strong>{{d.newValue | currency}}</strong></div>
                            </div>
                            <div class="row">
                                <div class="col-4 text-right"><b>Delta Amount:</b></div>
                                <div class="col-8"><span class="text-danger"
                                        [ngClass]="{'setPerens' : isNegitive(d.deltaAmount)}"><strong>{{d.deltaAmount
                                            | negToPos | currency}}</strong></span></div>
                            </div>
                            <div class="row">
                                <div class="col-4 text-right"><b>Comm Old:</b></div>
                                <div class="col-8"><strong>{{d.commissionsOldValue | currency}}</strong></div>
                            </div>
                            <div class="row">
                                <div class="col-4 text-right"><b>Comm New:</b></div>
                                <div class="col-8"><strong>{{d.commissionsNewValue | currency}}</strong></div>
                            </div>
                        </mdb-card-text>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>

        <!-- Desktop-->
        <div class="d-none d-md-block">
            <div class="row justify-content-md-center">
                <div class="col-md-12 my-4">
                    <div class="card card-cascade narrower">
                        <mdb-card>
                            <mdb-body>
                                <div class="row">
                                    <div class="col-md-12 mr-0">
                                        <div class="view view-cascade gradient-card-header blue-gradient py-2">
                                            <h6 class="h6-responsive card-title font-weight-bold mb-0">Expense Window
                                                Accountability</h6>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mr-0">
                                        <div class="card-body card-body-cascade">
                                            <div class="row">
                                                <div class="table-responsive">
                                                    <table mdbTable class="table-fixed" mdbTable striped="true" small="true" class="z-depth-1">
                                                        <thead class="text-muted h6">
                                                            <tr>
                                                                <th class="th-lg">Confirmation Number</th>
                                                                <th class="th-lg">User Name</th>
                                                                <th class="th-lg">User Groups</th>
                                                                <th class="th-lg">Property Name</th>
                                                                <th class="th-lg">Old Value</th>
                                                                <th class="th-lg">New Value</th>
                                                                <th class="th-lg">Delta Amount</th>
                                                                <th class="th-lg">Commissions Old Value</th>
                                                                <th class="th-lg">Commissions New Value</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody class="h5">
                                                            <tr *ngFor="let d of v.items">
                                                                <td>
                                                                    <a *ngIf='d.confirmationNumber' type="button"
                                                                        (click)="showDetails(d.segmentRowId, d.resAuditLogEntryId);"><strong>{{d.confirmationNumber}}</strong></a>
                                                                </td>
                                                                <td>
                                                                    <strong>{{d.userFullName}}</strong>
                                                                </td>
                                                                <td>
                                                                    <strong>{{d.userGroups}}</strong>
                                                                </td>
                                                                <td>
                                                                    <strong>{{d.propertyName}}</strong>
                                                                </td>
                                                                <td>
                                                                    <strong>{{d.oldValue | currency}}</strong>
                                                                </td>
                                                                <td>
                                                                    <strong>{{d.newValue | currency}}</strong>
                                                                </td>
                                                                <td>
                                                                    <span class="text-danger"
                                                                        [ngClass]="{'setPerens' : isNegitive(d.deltaAmount)}"><strong>{{d.deltaAmount
                                                                            | negToPos | currency}}</strong></span>
                                                                </td>
                                                                <td>
                                                                    <strong>{{d.commissionsOldValue |
                                                                        currency}}</strong>
                                                                </td>
                                                                <td>
                                                                    <strong>{{d.commissionsNewValue |
                                                                        currency}}</strong>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mdb-body>
                        </mdb-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>